import { FileText, Upload, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { formatDistanceToNow } from "date-fns";

export default function ReferenceDocuments() {
  // todo: remove mock functionality
  const references = [
    {
      id: "1",
      name: "Machine Learning Research Paper.pdf",
      type: "PDF",
      size: "2.4 MB",
      uploadedAt: new Date(Date.now() - 1000 * 60 * 60 * 3),
      tags: ["Research", "ML"],
    },
    {
      id: "2",
      name: "Product Requirements Doc.docx",
      type: "DOCX",
      size: "856 KB",
      uploadedAt: new Date(Date.now() - 1000 * 60 * 60 * 24),
      tags: ["Product", "Requirements"],
    },
    {
      id: "3",
      name: "Technical Specifications.md",
      type: "Markdown",
      size: "124 KB",
      uploadedAt: new Date(Date.now() - 1000 * 60 * 60 * 48),
      tags: ["Technical", "Specs"],
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold mb-2">Reference Documents</h1>
          <p className="text-muted-foreground">Attached sources and materials (LM Notebook style)</p>
        </div>
        <Button data-testid="button-upload-document">
          <Upload className="h-4 w-4 mr-2" />
          Upload Document
        </Button>
      </div>

      <div className="space-y-3">
        {references.map((doc) => (
          <Card key={doc.id} className="p-4 hover-elevate cursor-pointer transition-all" data-testid={`document-${doc.id}`}>
            <div className="flex items-center gap-4">
              <div className="p-3 bg-muted rounded-lg">
                <FileText className="h-5 w-5 text-muted-foreground" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1 min-w-0">
                    <h3 className="font-medium mb-1 truncate">{doc.name}</h3>
                    <p className="text-sm text-muted-foreground">
                      {doc.type} • {doc.size} • {formatDistanceToNow(doc.uploadedAt, { addSuffix: true })}
                    </p>
                  </div>
                  <div className="flex gap-1 flex-wrap">
                    {doc.tags.map((tag, index) => (
                      <Badge key={index} variant="secondary" className="text-xs">
                        {tag}
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
